<template>
    <div  >
            <top-navbar></top-navbar>
    
    
            <div  class="mb-5  background_color " >
              <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Product Sales</a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/mproduct/index"> Manage Product  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Create Product  </h6>
                <!-- <h6 class="custom-maintitle mb-2"><b>Create Customer </b></h6> -->
                <div style=" padding-bottom: 100px;" class="container-fluid ">
                <div class="card bdr-rad2 mt-1 shadow p-2 ">
                <div class="card-body">


                    <form @submit.prevent="SaveProduct()" >

<div class="row">
 
  
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Brand </label>
            <v-select  label="brand_name" v-model="products.id_brand" :options="brands"   ></v-select>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Product Line </label>
            <v-select label="label"  v-model="products.P_category" :options="productLineOption" ></v-select>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Product Code </label>
            <input  v-model="products.P_code"  style="font-size: small;" class="form-control bdr-rad" required>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Product Description</label>
          
          <textarea v-model="products.P_description" class="form-control bdr-rad" rows="2"></textarea>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Product Price </label>
           
            <input  v-model="products.P_internal_selling_price"  style="font-size: small;" class="form-control bdr-rad" required>
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Supplier</label>
            <v-select label="sup_name"  v-model="products.P_idsupplier" :options="suppliers" ></v-select>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">HS Code</label>
            <input  v-model="products.hs_code"  style="font-size: small;" class="form-control bdr-rad" >
    </div>
  </div>

  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">Fuel Type </label>
            <v-select label="label"  v-model="products.fuel_type" :options="productfuel" ></v-select>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Vehicles</label>
            <v-select label="modelname" v-model="products.vehicle_list" :options="vehicles" :reduce="vehicle => vehicle.modelname" ></v-select>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group required">
            <label class="custom-label" style="font-size: small;">Location</label>
            <v-select label="location_no"  :options="Locations" ></v-select>
    </div>
  </div>
  <div class="col-md-3">
    <div class="form-group ">
            <label class="custom-label" style="font-size: small;">ROQ</label>
            <input  v-model="products.ROQ"  style="font-size: small;" class="form-control bdr-rad" >
    </div>
  </div>
</div>













   

    <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  type="submit" class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Create</button>
    </div>
    </div>
    <br><br>


</form>




                </div>
                </div>
           
            </div>
           
          </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
      import vSelect from 'vue-select';
      import 'vue-select/dist/vue-select.css';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadSalespeople()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
           
        total:0,
        selectedOption: null, // Store the selected option
       

        brands:[],
        suppliers:[],
        vehicles:[],
        Locations:[],
        products:{},
       
      
      productLineOption: [
            { label: 'Select Category', value: '' },
            { label: 'Spare Parts', value: '1' }
            // Add more options as needed
        ],
        productfuel: [
            { label: 'Select Fuel Type', value: '' },
            { label: 'Diesel', value: 'Diesel' },
            { label: 'petrol', value: 'petrol' },
            { label: 'both', value: 'both' },
            // Add more options as needed
        ],
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },

        methods : {
    

          async loadSalespeople() {
       
     
      try {
        const { data} = await  axios.get('/mproduct/brandload',{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.brands = data.brands;
         this.suppliers = data.suppliers;
         this.vehicles = data.vehicles;
         this.Locations = data.Locations;
        
        
      } catch (error) {
        console.log(error.response);
      }
    },

    async SaveProduct() {
       
      console.log(this.products);
   
    console.log("amila");
       try {
         const { data} = await  axios.post('/mproduct/create',{userid:this.userid,products:this.products},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
        if(data.status==200){
          this.$router.push('/mproduct/index');
        }
          
           
         
       } catch (error) {
         console.log(error.response);
       }
     },
       

     

    },
    
    }
    
    </script>

    <style scoped>
.vs__dropdown-toggle {
      border-radius: 10px !important;
    border-top-left-radius: 10px !important;
    border-top-right-radius: 10px !important;
    border-bottom-right-radius: 10px !important;

}

    </style>
    
